import { DeviceClasses } from "../models/DeviceClasses";
import { pageTypeInfo } from "../models/PageTypes";
import PaneObject from "../models/PaneObject";
import { itx, noItx } from "./itx";

export default class TranslateValueFunctions {
  public get className(): string {
    return "TranslateValueFunctions"; // no itx
  }

  translateNamesAfterLanguageSelection() {
    state.floors.name = state.translate("components.plural.Floor", "Etagen");
    state.cabinets.name = state.translate("components.plural.Cabinet", "Schaltschränke");
    state.templateGroups.name = state.translate("components.plural.Product", "Produkte");
    state.addresses.name = state.translate("treeViewModel.knxAdresses", "Knx Adressen");
    state.sceneGroup.name = state.translate("treeViewModel.Scene", "Szenen und Multiplexer");
    state.pageGroups.name = state.translate("treeViewModel.documents", "Dokumente");
    state.topologies.name = state.translate("treeViewModel.topology", "Topologie");
    state.cableTypes.name = state.translate("components.plural.CableType", "Kabeltypen");

    state.templateGroups.forEach((tg) => {
      if (tg.tag === "C1") return;
      if (tg.templateGroupType == DeviceClasses.Unknown) {
        tg.name = state.translate("components.plural.Unspecified", "Nicht spezifiziert");
      } else if (tg.templateGroupType == DeviceClasses.Actor) {
        tg.name =
          itx("components.plural.Actor", "Aktoren") +
          " " +
          itx("&", "&") +
          " " +
          itx("components.CabinetElement", "Schaltschrankelemente");
      } else if (tg.templateGroupType == DeviceClasses.SensorNew) {
        tg.name = itx("components.plural.SensorNew", "Sensoren");
      } else if (tg.templateGroupType == DeviceClasses.Button) {
        tg.name = itx("components.plural.Button", "Tasten");
      } else if (tg.templateGroupType == DeviceClasses.DecentralActor) {
        tg.name = itx("components.plural.DecentralActor", "Dezentrale Aktoren");
      }

      //     // clean up template groups with classes
      // if (tg.templateGroupType == DeviceClasses.Gateway) {
      //         tg.name = state.translate("components.plural.Gateway", "Gateways");
      //       } else if (tg.templateGroupType == DeviceClasses.Other) {
      //         tg.name = state.translate("components.plural.Other", "Other");
      //       } else if (tg.templateGroupType == DeviceClasses.ButtonActor) {
      //         tg.name = state.translate("components.plural.ButtonActor", "Taster Aktoren");}
    });
    state.pageGroups.forEach((pg) => {
      if (pg.tag == "10") {
        pg.name = state.translate("pageDocumentType.buildingPlans", "Gebäudepläne");
      }
      pg.pages.forEach((page) => {
        if (pageTypeInfo(page.documentType.type)?.isList) {
          const name = state.translate(`pageDocumentType.${page.documentType.type}`, page.documentType.type);
          page.documentType.name = name;
          pg.name = name;
        }
      });
    });
    // has to be done here because state is by init of this panes not jet full init
    state.activePanes.items.forEach((pane) => {
      switch ((pane.item as PaneObject).type) {
        // case "home":
        //   pane.tag=state.translate("","ESTADA")
        //   break;
        case noItx("help"):
          pane.tag = state.translate("menuBar.help", "Hilfe");
          break;
        case noItx("ai"):
          pane.tag = state.translate("assistend", "Assistent");
          break;
      }
    });

    // force every tree node (which computes labels/tags via itx() at render time) to redraw
    state.languageVersion.value = state.languageVersion.value + 1;
  }
}
